module.exports = __webpack_public_path__ + "static/media/opened-cans-top-view.54c918a8.png";